import { createSelector } from 'reselect';

import { TRootState } from '@/redux/rootReducer';

export const getUserFavorites = createSelector(
  [(state: TRootState) => state.wishlists],
  wishlists => {
    return {
      rentals: wishlists.rentals,
      campgrounds: wishlists.campgrounds,
    };
  },
);
